import { cn } from '@/utils/cn';
import React from 'react';

function ListItem({ children, className = '', ...rest }) {
  return (
    <li
      className={cn(
        'text-14 lg:text-16 text-coarse-wool font-encode-sans font-normal leading-18 lg:leading-20 tracking-[0.28px] lg:tracking-[0.32px]',
        className,
      )}
      {...rest}
    >
      {children}
    </li>
  );
}

export default ListItem;
